export default "__VITE_ASSET__B1HI3Vq1__"